import React, { memo } from 'react'

const NotFound = () => (
  <div className="flex h-screen w-screen items-center justify-center">404 | Not Found</div>
)

export default memo(NotFound)
